var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.cadastroOriginal.tipoReurbIndividual
      ? _c(
          "div",
          { attrs: { slot: "body" }, slot: "body" },
          [
            _c(
              "el-row",
              { attrs: { span: 24 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("app-display", {
                      attrs: {
                        id: "TIPO_REURB",
                        label: "Tipo de Reurb:",
                        content: _vm.formataTipoReurb(
                          _vm.cadastroOriginal.tipoReurbIndividual
                        )
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("app-display", {
                      attrs: {
                        id: "TIPO_REQUERENTE",
                        label: "Tipo requerente:",
                        content: _vm.formatarTexto(
                          _vm.cadastroOriginal.tipoRequerente ||
                            _vm.cadastroOriginal.interessado.pessoa.tipo
                        )
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm.isTipoRequerentePj
              ? _c(
                  "div",
                  { attrs: { slot: "body" }, slot: "body" },
                  [
                    _c("app-divider", { attrs: { label: "Dados Requerente" } }),
                    _c(
                      "el-row",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              attrs: {
                                id: "CNPJ",
                                label: "CNPJ:",
                                content: _vm.getData.cnpj
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              attrs: {
                                id: "RAZAO_SOCIAL",
                                label: "Razão social:",
                                content: _vm.getData.razaoSocial
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    !_vm.cadastroOriginal
      ? _c(
          "div",
          [
            _c(
              "el-col",
              [
                _c("app-display", {
                  attrs: {
                    content: "Não foi informado nenhum dado durante o cadastro."
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2256ae60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2256ae60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/ma/InformacoesComplementares.vue
// module id = null
// module chunks = 